import React, { Component } from "react";
import { Grid, Header, Button, Segment, Transition } from "semantic-ui-react";
import { connect } from "react-redux";
import { Config } from "../../../data/config";

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  transitionBack() {
    const { setServiceAvailable } = this.props;

    this.setState({
      animation: "fade left",
      visible: false
    });
    setTimeout(() => {
      setServiceAvailable(null, "fade right");
    }, 400);
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(2, "fade left");
    }, 400);
  }

  render() {
    const { visible, animation } = this.state;
    const { addressText, connection } = this.props;
    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              {addressText}
            </Header>
            <Grid className="instant-activation width__xs">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Segment inverted textAlign="center">
                    <div className="circle-tick" />
                    <Header as="h3" className="title" textAlign="center">
                      {connection.isFibrestream && ('Fibrestream Available!')}
                      {!connection.isFibrestream && connection.isOnNet && ('Beanfield Fibre Available')}
                    </Header>

                    {connection.isFibrestream && (
                      <Segment
                        className="sub__instant-activation mx-4"
                        textAlign="center"
                      >
                        <p className="text-white f-size--14">
                          FibreStream was recently acquired by Beanfield, a leading
                          telecommunications company with a shared customer-centric approach.
                          All installations, billing and support for FibreStream services
                          will be provided by Beanfield.
                        </p>
                      </Segment>
                    )}
                    {connection.isFibrestream && (
                      <p className="text-white f-size--14">
                        Click Continue to start your order
                      </p>
                    )}
                    {!connection.isFibrestream && connection.isOnNet && (
                      <Segment
                        className="sub__instant-activation mx-4"
                        textAlign="center"
                      >
                        <Header as="h5" className="itc-std-md f-size--14">
                          <i aria-hidden="true" className="bolt icon" />
                          Speeds starting from 1 gbps
                        </Header>
                        <p className="text-white f-size--14">
                          FibreStream was recently acquired by Beanfield,
                          a leading telecommunications company with even
                          faster speeds!  It looks like Beanfield is already
                          servicing your building.
                        </p>
                      </Segment>
                    )}
                    {!connection.isFibrestream && connection.isOnNet && (
                        <p className="text-white f-size--14">
                          Please continue below to start your order with Beanfield.
                        </p>
                    )}

                    {connection.isFibrestream &&
                    <Button
                      className="btn--full"
                      size="medium"
                      target="_blank"
                      href={`${Config.beanfieldOrderPrefix}/residential-order-fibrestream?address_id=${connection.addressId}`}
                    >
                      Continue
                    </Button>
                    }
                    {!connection.isFibrestream && connection.isOnNet &&
                    <Button
                      className="btn--full"
                      size="medium"
                      target="_blank"
                      href={`${Config.beanfieldOrderPrefix}/en/tor/residential-order?address_id=${connection.addressId}`}
                    >
                      Get Fibre Now &nbsp; <i class="external alternate icon" />
                    </Button>
                    }
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="px-4 py-0 learn-more__text">
                <Grid.Column textAlign="center">
                  {connection.isFibrestream &&
                  <p className="itc-std-md f-size--14">
                    All services are provided on a month to month basis with free installation and no
                    contracts. Cancel anytime, risk free.
                  </p>
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addressText: state.connection.addressText,
    connection: state.connection
  };
};

export default connect(mapStateToProps)(Step1);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step1.js